import { apiURL, callAPI } from 'api/main';

import { middlewareInvitations } from './middleware';

export default async (): Promise<IMatchmakingInvitation[]> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/v3/sys/match/invites`,
      method: 'GET',
      needToken: true,
    });

    const { data } = res.request;

    if (data) {
      return middlewareInvitations(data);
    }

    return [];
  } catch (ex) {
    return [];
  }
};
